import React, {useState} from 'react';
import {IImagePreview} from "@ui/imageListCustom/types";
import ImagePreviewBadge from "@ui/imageListCustom/ImagePreviewBadge";
import {ImageList, ImageListItem, ImageListItemBar} from "@mui/material";
import {sx} from './sx'
import Lightbox from "yet-another-react-lightbox";
import {useMedia} from "@hooks/ui/useMedia";
import "yet-another-react-lightbox/styles.css";
import Download from "yet-another-react-lightbox/plugins/download";
import NotFound from '@ui/notFound/NotFound';

interface IProps {
	images: IImagePreview[]
	cols?: number
}

const ImageListCustom = ({images, cols}: IProps) => {
	
	const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
	const [open, setOpen] = useState<boolean>(false);
	
	const {isDesktop} = useMedia()
	
	const list = images?.map((imagePreview, index) => {
		const onClick = () => {
			setCurrentImageIndex(index);
			setOpen(true);
		}
		return (
			<ImageListItem
				onClick={onClick}
				key={imagePreview.src}
				sx={sx.item}
			>
				<img
					src={imagePreview.src}
					alt={imagePreview.src}
					loading="lazy"
					className={'image-preview-custom'}
				/>
				<ImagePreviewBadge badge={imagePreview.badge} badgeTitle={imagePreview.badgeTitle}/>
				<ImageListItemBar
					title={imagePreview.dateAdd}
				/>
			</ImageListItem>
		)
	})
	
	const onClose = () => {
		setCurrentImageIndex(0);
		setOpen(false);
	};
	
	
	if (!images?.length) {
		return <NotFound/>
	}
	
	return (
		<>
			<ImageList
				rowHeight={164}
				cols={cols ? cols : isDesktop ? 3 : 1}
			>
				{list}
			</ImageList>
			
			{open && <Lightbox
                index={currentImageIndex}
                open={open}
                close={onClose}
                slides={images}
                plugins={[Download]}
            />}
		</>
	);
};

export default ImageListCustom;